"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _templateObject;
const _excluded = ["children", "spaceType", "verticalSpace", "horizontalSpace", "topSpace", "bottomSpace", "leftSpace", "rightSpace", "styles"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function Spacer(_ref) {
  let {
      children,
      spaceType,
      verticalSpace,
      horizontalSpace,
      topSpace,
      bottomSpace,
      leftSpace,
      rightSpace,
      styles
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    spaceType: spaceType,
    verticalSpace: verticalSpace,
    horizontalSpace: horizontalSpace,
    topSpace: topSpace,
    bottomSpace: bottomSpace,
    leftSpace: leftSpace,
    rightSpace: rightSpace,
    styles: styles
  }, props), children);
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), _ref2 => {
  let {
    spaceType,
    verticalSpace,
    horizontalSpace,
    topSpace,
    bottomSpace,
    leftSpace,
    rightSpace
  } = _ref2;
  let styles = '';
  if (verticalSpace) {
    styles += "\n        ".concat(spaceType, "-top: ").concat(verticalSpace, "px;\n        ").concat(spaceType, "-bottom: ").concat(verticalSpace, "px;\n      ");
  }
  if (horizontalSpace) {
    styles += "\n        ".concat(spaceType, "-left: ").concat(horizontalSpace, "px;\n        ").concat(spaceType, "-right: ").concat(horizontalSpace, "px;\n      ");
  }
  if (topSpace) {
    styles += "\n        ".concat(spaceType, "-top: ").concat(topSpace, "px;\n      ");
  }
  if (bottomSpace) {
    styles += "\n        ".concat(spaceType, "-bottom: ").concat(bottomSpace, "px;\n      ");
  }
  if (leftSpace) {
    styles += "\n        ".concat(spaceType, "-left: ").concat(leftSpace, "px;\n      ");
  }
  if (rightSpace) {
    styles += "\n        ".concat(spaceType, "-right: ").concat(rightSpace, "px;\n      ");
  }
  return styles;
}, _ref3 => {
  let {
    styles
  } = _ref3;
  return styles;
});
var _default = exports.default = Spacer;